import vikrant from "../../images/16thMarch2023Event/images/agenda/vikrant.jpg"
import vikrant2 from "../../images/16thMarch2023Event/images/agenda/vikrant2.jpg"
import vikrant3 from "../../images/16thMarch2023Event/images/agenda/vikrant3.jpg"
import ramanSharma from "../../images/16thMarch2023Event/images/agenda/ramanSharma.jpg"
import ramanSharma2 from "../../images/16thMarch2023Event/images/agenda/ramanSharma2.jpg"
import ramanSharma3 from "../../images/16thMarch2023Event/images/agenda/ramanSharma3.jpg"
import ramanSharma4 from "../../images/16thMarch2023Event/images/agenda/ramanSharma4.jpg"
import ramanSharma5 from "../../images/16thMarch2023Event/images/agenda/ramanSharma5.jpg"
import ramanSharma6 from "../../images/16thMarch2023Event/images/agenda/ramanSharma6.jpg"
import ramanSharma7 from "../../images/16thMarch2023Event/images/agenda/ramanSharma7.jpg"
import ramanSharma8 from "../../images/16thMarch2023Event/images/agenda/ramanSharma8.jpg"
import ramanSharma9 from "../../images/16thMarch2023Event/images/agenda/ramanSharma9.jpg"
import ramanSharma10 from "../../images/16thMarch2023Event/images/agenda/ramanSharma10.jpg"
import sanjayRakesh from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh.jpg"
import sanjayRakesh1 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh1.jpg"
import sanjayRakesh2 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh2.jpg"
import sanjayRakesh3 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh3.jpg"
import sanjayRakesh4 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh4.jpg"
import sanjayRakesh5 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh5.jpg"
import sanjayRakesh6 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh6.jpg"
import sanjayRakesh7 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh7.jpg"
import sanjayRakesh8 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh8.jpg"
import sanjayRakesh9 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh9.jpg"
import sanjayRakesh10 from "../../images/16thMarch2023Event/images/agenda/sanjayRakesh10.jpg"
import arindamLehri from "../../images/16thMarch2023Event/images/agenda/arindamLehri.jpg"
import arindamLehri3 from "../../images/16thMarch2023Event/images/agenda/arindamLehri3.jpg"
import arindamLehri4 from "../../images/16thMarch2023Event/images/agenda/arindamLehri4.jpg"
import arindamLehri5 from "../../images/16thMarch2023Event/images/agenda/arindamLehri5.jpg"
import arindamLehri6 from "../../images/16thMarch2023Event/images/agenda/arindamLehri6.jpg"
import arindamLehri7 from "../../images/16thMarch2023Event/images/agenda/arindamLehri7.jpg"
import arindamLehri8 from "../../images/16thMarch2023Event/images/agenda/arindamLehri8.jpg"
import arindamLehri9 from "../../images/16thMarch2023Event/images/agenda/arindamLehri9.jpg"
import arindamLehri10 from "../../images/16thMarch2023Event/images/agenda/arindamLehri10.jpg"
import arindamLehri11 from "../../images/16thMarch2023Event/images/agenda/arindamLehri11.jpg"
import arindamLehri12 from "../../images/16thMarch2023Event/images/agenda/arindamLehri12.jpg"
import arindamLehri13 from "../../images/16thMarch2023Event/images/agenda/arindamLehri13.jpg"
import arindamLehri14 from "../../images/16thMarch2023Event/images/agenda/arindamLehri14.jpg"
import arindamLehri15 from "../../images/16thMarch2023Event/images/agenda/arindamLehri15.jpg"
import arindamLehri16 from "../../images/16thMarch2023Event/images/agenda/arindamLehri16.jpg"
import arindamLehri17 from "../../images/16thMarch2023Event/images/agenda/arindamLehri17.jpg"
import aayushi from "../../images/16thMarch2023Event/images/agenda/aayushi.jpg"
import aayushi1 from "../../images/16thMarch2023Event/images/agenda/aayushi1.jpg"
import aayushi2 from "../../images/16thMarch2023Event/images/agenda/aayushi2.jpg"
import aayushi3 from "../../images/16thMarch2023Event/images/agenda/aayushi3.jpg"
import aayushi4 from "../../images/16thMarch2023Event/images/agenda/aayushi4.jpg"
import AnilPokhriyal from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal.jpg"
import AnilPokhriyal1 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal1.jpg"
import AnilPokhriyal2 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal2.jpg"
import AnilPokhriyal3 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal3.jpg"
import AnilPokhriyal4 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal4.jpg"
import AnilPokhriyal5 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal5.jpg"
import AnilPokhriyal6 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal6.jpg"
import AnilPokhriyal7 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal7.jpg"
import AnilPokhriyal8 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal8.jpg"
import AnilPokhriyal9 from "../../images/16thMarch2023Event/images/agenda/anilPokhriyal9.jpg"
import sunilWadhwa from "../../images/16thMarch2023Event/images/agenda/sunilWadhwa.jpg"
import sunilWadhwa1 from "../../images/16thMarch2023Event/images/agenda/sunilWadhwa1.jpg"
import sunilWadhwa2 from "../../images/16thMarch2023Event/images/agenda/sunilWadhwa2.jpg"
import sunilWadhwa3 from "../../images/16thMarch2023Event/images/agenda/sunilWadhwa3.jpg"
import anuMehta from "../../images/16thMarch2023Event/images/agenda/anuMehta.jpg"
import anuMehta1 from "../../images/16thMarch2023Event/images/agenda/anuMehta1.jpg"
import anuMehta2 from "../../images/16thMarch2023Event/images/agenda/anuMehta2.jpg"
import anuMehta3 from "../../images/16thMarch2023Event/images/agenda/anuMehta3.jpg"
import anuMehta4 from "../../images/16thMarch2023Event/images/agenda/anuMehta4.jpg"
import chandrasekar from "../../images/16thMarch2023Event/images/agenda/chandrasekar.jpg"
import chandrasekar1 from "../../images/16thMarch2023Event/images/agenda/chandrasekar1.jpg"
import anuPrasad from "../../images/16thMarch2023Event/images/agenda/anuPrasad.jpg"
import anuPrasad1 from "../../images/16thMarch2023Event/images/agenda/anuPrasad1.jpg"
import anuPrasad2 from "../../images/16thMarch2023Event/images/agenda/anuPrasad2.jpg"
import anuPrasad3 from "../../images/16thMarch2023Event/images/agenda/anuPrasad3.jpg"
import anuPrasad4 from "../../images/16thMarch2023Event/images/agenda/anuPrasad4.jpg"
import anuPrasad5 from "../../images/16thMarch2023Event/images/agenda/anuPrasad5.jpg"
import monikaHalan from "../../images/16thMarch2023Event/images/agenda/monikaHalan.jpg"
import monikaHalan1 from "../../images/16thMarch2023Event/images/agenda/monikaHalan1.jpg"
import shruteeGanguly from "../../images/16thMarch2023Event/images/agenda/shruteeGanguly.jpg"
import shruteeGanguly2 from "../../images/16thMarch2023Event/images/agenda/shruteeGanguly2.jpg"
import shruteeGanguly3 from "../../images/16thMarch2023Event/images/agenda/shruteeGanguly3.jpg"
import shruteeGanguly4 from "../../images/16thMarch2023Event/images/agenda/shruteeGanguly4.jpg"
import peterImanual from "../../images/16thMarch2023Event/images/agenda/peterImanual.jpg"

// orientation gallery
import orientation1 from "../../images/newDesign/orientationPrograme/DSC_0022.jpg"
import orientation2 from "../../images/newDesign/orientationPrograme/DSC_0027.jpg"
import orientation3 from "../../images/newDesign/orientationPrograme/DSC_0039.jpg"
import orientation4 from "../../images/newDesign/orientationPrograme/DSC_0052.jpg"
import orientation5 from "../../images/newDesign/orientationPrograme/DSC_0064.jpg"
import orientation6 from "../../images/newDesign/orientationPrograme/DSC_0077.jpg"
import orientation7 from "../../images/newDesign/orientationPrograme/DSC_0094.jpg"
import orientation8 from "../../images/newDesign/orientationPrograme/DSC_0101.jpg"
import orientation9 from "../../images/newDesign/orientationPrograme/DSC_0108.jpg"
import orientation10 from "../../images/newDesign/orientationPrograme/DSC_0150.jpg"
import orientation11 from "../../images/newDesign/orientationPrograme/DSC_0221.jpg"
import orientation12 from "../../images/newDesign/orientationPrograme/DSC_0245.jpg"
import orientation13 from "../../images/newDesign/orientationPrograme/DSC_0266.jpg"
import orientation14 from "../../images/newDesign/orientationPrograme/DSC_0274.jpg"
import orientation15 from "../../images/newDesign/orientationPrograme/DSC_0291.jpg"
import orientation16 from "../../images/newDesign/orientationPrograme/DSC_0297.jpg"
import orientation17 from "../../images/newDesign/orientationPrograme/DSC_0305.jpg"
import orientation18 from "../../images/newDesign/orientationPrograme/DSC_0346.jpg"
import orientation19 from "../../images/newDesign/orientationPrograme/DSC_0371.jpg"
import orientation20 from "../../images/newDesign/orientationPrograme/DSC_0373.jpg"
import orientation21 from "../../images/newDesign/orientationPrograme/DSC_0388.jpg"
import orientation22 from "../../images/newDesign/orientationPrograme/DSC_0395.jpg"
import orientation23 from "../../images/newDesign/orientationPrograme/DSC_0397.jpg"
import orientation24 from "../../images/newDesign/orientationPrograme/DSC_0409.jpg"
import orientation25 from "../../images/newDesign/orientationPrograme/DSC_0422.jpg"
import orientation26 from "../../images/newDesign/orientationPrograme/DSC_0426.jpg"
import orientation27 from "../../images/newDesign/orientationPrograme/DSC_0429.jpg"
import orientation28 from "../../images/newDesign/orientationPrograme/DSC_0439.jpg"
import orientation29 from "../../images/newDesign/orientationPrograme/DSC_0444.jpg"
import orientation30 from "../../images/newDesign/orientationPrograme/DSC_0451.jpg"
import orientation31 from "../../images/newDesign/orientationPrograme/DSC_0454.jpg"
import orientation32 from "../../images/newDesign/orientationPrograme/Sachin3.jpg"
import orientation33 from "../../images/newDesign/orientationPrograme/Screenshot.jpg"
import orientation34 from "../../images/newDesign/orientationPrograme/Screenshott.jpg"
import orientation35 from "../../images/newDesign/orientationPrograme/pictures/Dinesh.jpg"
import orientation36 from "../../images/newDesign/orientationPrograme/pictures/DSC_0004.jpg"
import orientation37 from "../../images/newDesign/orientationPrograme/pictures/DSC_0005.jpg"
import orientation38 from "../../images/newDesign/orientationPrograme/pictures/DSC_0006.jpg"
import orientation39 from "../../images/newDesign/orientationPrograme/pictures/DSC_0007.jpg"
import orientation40 from "../../images/newDesign/orientationPrograme/pictures/DSC_0008.jpg"
import orientation41 from "../../images/newDesign/orientationPrograme/pictures/DSC_0011.jpg"
import orientation42 from "../../images/newDesign/orientationPrograme/pictures/DSC_0012.jpg"
import orientation43 from "../../images/newDesign/orientationPrograme/pictures/DSC_0016.jpg"
import orientation44 from "../../images/newDesign/orientationPrograme/pictures/DSC_0017.jpg"
import orientation45 from "../../images/newDesign/orientationPrograme/pictures/DSC_0021.jpg"
import orientation46 from "../../images/newDesign/orientationPrograme/pictures/DSC_0023.jpg"
import orientation47 from "../../images/newDesign/orientationPrograme/pictures/DSC_0025.jpg"
import orientation48 from "../../images/newDesign/orientationPrograme/pictures/DSC_0031.jpg"
import orientation49 from "../../images/newDesign/orientationPrograme/pictures/DSC_0040.jpg"
import orientation50 from "../../images/newDesign/orientationPrograme/pictures/DSC_0042.jpg"
import orientation51 from "../../images/newDesign/orientationPrograme/pictures/DSC_0044.jpg"
import orientation52 from "../../images/newDesign/orientationPrograme/pictures/DSC_0046.jpg"
import orientation53 from "../../images/newDesign/orientationPrograme/pictures/DSC_0047.jpg"
import orientation54 from "../../images/newDesign/orientationPrograme/pictures/DSC_0049.jpg"
import orientation55 from "../../images/newDesign/orientationPrograme/pictures/DSC_0053.jpg"
import orientation56 from "../../images/newDesign/orientationPrograme/pictures/DSC_0054.jpg"
import orientation57 from "../../images/newDesign/orientationPrograme/pictures/DSC_0056.jpg"
import orientation58 from "../../images/newDesign/orientationPrograme/pictures/DSC_0059.jpg"
import orientation59 from "../../images/newDesign/orientationPrograme/pictures/DSC_0061.jpg"
import orientation60 from "../../images/newDesign/orientationPrograme/pictures/DSC_0062.jpg"
import orientation61 from "../../images/newDesign/orientationPrograme/pictures/DSC_0078.jpg"
import orientation62 from "../../images/newDesign/orientationPrograme/pictures/DSC_0080.jpg"
import orientation63 from "../../images/newDesign/orientationPrograme/pictures/DSC_0082.jpg"
import orientation64 from "../../images/newDesign/orientationPrograme/pictures/DSC_0083.jpg"
import orientation65 from "../../images/newDesign/orientationPrograme/pictures/DSC_0084.jpg"
import orientation66 from "../../images/newDesign/orientationPrograme/pictures/DSC_0086.jpg"
import orientation67 from "../../images/newDesign/orientationPrograme/pictures/DSC_0088.jpg"
import orientation68 from "../../images/newDesign/orientationPrograme/pictures/DSC_0089.jpg"
import orientation69 from "../../images/newDesign/orientationPrograme/pictures/DSC_0093.jpg"
import orientation70 from "../../images/newDesign/orientationPrograme/pictures/DSC_0095.jpg"
import orientation71 from "../../images/newDesign/orientationPrograme/pictures/DSC_0097.jpg"
import orientation72 from "../../images/newDesign/orientationPrograme/pictures/DSC_0106.jpg"
import orientation73 from "../../images/newDesign/orientationPrograme/pictures/DSC_0110.jpg"
import orientation74 from "../../images/newDesign/orientationPrograme/pictures/DSC_0112.jpg"
import orientation75 from "../../images/newDesign/orientationPrograme/pictures/DSC_0119.jpg"
import orientation76 from "../../images/newDesign/orientationPrograme/pictures/DSC_0137.jpg"
import orientation77 from "../../images/newDesign/orientationPrograme/pictures/DSC_0142.jpg"
import orientation78 from "../../images/newDesign/orientationPrograme/pictures/DSC_0146.jpg"
import orientation79 from "../../images/newDesign/orientationPrograme/pictures/DSC_0148.jpg"
import orientation80 from "../../images/newDesign/orientationPrograme/pictures/DSC_0149.jpg"
import orientation81 from "../../images/newDesign/orientationPrograme/pictures/DSC_0151.jpg"
import orientation82 from "../../images/newDesign/orientationPrograme/pictures/DSC_0154.jpg"
import orientation83 from "../../images/newDesign/orientationPrograme/pictures/DSC_0158.jpg"
import orientation84 from "../../images/newDesign/orientationPrograme/pictures/DSC_0165.jpg"
import orientation85 from "../../images/newDesign/orientationPrograme/pictures/DSC_0173.jpg"
import orientation86 from "../../images/newDesign/orientationPrograme/pictures/DSC_0174.jpg"
import orientation87 from "../../images/newDesign/orientationPrograme/pictures/DSC_0176.jpg"
import orientation88 from "../../images/newDesign/orientationPrograme/pictures/DSC_0178.jpg"
import orientation89 from "../../images/newDesign/orientationPrograme/pictures/DSC_0180.jpg"
import orientation90 from "../../images/newDesign/orientationPrograme/pictures/DSC_0181.jpg"
import orientation91 from "../../images/newDesign/orientationPrograme/pictures/DSC_0182.jpg"
import orientation92 from "../../images/newDesign/orientationPrograme/pictures/DSC_0415.jpg"
import orientation93 from "../../images/newDesign/orientationPrograme/pictures/DSC_0420.jpg"
import orientation94 from "../../images/newDesign/orientationPrograme/pictures/DSC_0421.jpg"
import orientation95 from "../../images/newDesign/orientationPrograme/pictures/DSC_0431.jpg"
import orientation96 from "../../images/newDesign/orientationPrograme/pictures/DSC_0440.jpg"
import orientation97 from "../../images/newDesign/orientationPrograme/pictures/DSC_0445.jpg"
import orientation98 from "../../images/newDesign/orientationPrograme/pictures/DSC_0452.jpg"
import orientation99 from "../../images/newDesign/orientationPrograme/pictures/DSC_0447.jpg"
import orientation100 from "../../images/newDesign/orientationPrograme/pictures/DSC_0455.jpg"
export const galleryPhotos = [
  vikrant,
  vikrant2,
  vikrant3,
  ramanSharma,
  ramanSharma2,
  ramanSharma3,
  ramanSharma4,
  ramanSharma5,
  ramanSharma6,
  ramanSharma7,
  ramanSharma8,
  ramanSharma9,
  ramanSharma10,
  sanjayRakesh,
  sanjayRakesh1,
  sanjayRakesh2,
  sanjayRakesh3,
  sanjayRakesh4,
  sanjayRakesh5,
  sanjayRakesh6,
  sanjayRakesh7,
  sanjayRakesh8,
  sanjayRakesh9,
  sanjayRakesh10,
  arindamLehri,
  arindamLehri3,
  arindamLehri4,
  arindamLehri5,
  arindamLehri6,
  arindamLehri7,
  arindamLehri8,
  arindamLehri9,
  arindamLehri10,
  arindamLehri11,
  arindamLehri12,
  arindamLehri13,
  arindamLehri14,
  arindamLehri15,
  arindamLehri16,
  arindamLehri17,
  aayushi,
  aayushi1,
  aayushi2,
  aayushi3,
  aayushi4,
  AnilPokhriyal,
  AnilPokhriyal1,
  AnilPokhriyal2,
  AnilPokhriyal3,
  AnilPokhriyal4,
  AnilPokhriyal5,
  AnilPokhriyal6,
  AnilPokhriyal7,
  AnilPokhriyal8,
  AnilPokhriyal9,
  sunilWadhwa,
  sunilWadhwa1,
  sunilWadhwa2,
  sunilWadhwa3,
  anuMehta,
  anuMehta1,
  anuMehta2,
  anuMehta3,
  anuMehta4,
  chandrasekar,
  chandrasekar1,
  anuPrasad,
  anuPrasad1,
  anuPrasad2,
  anuPrasad3,
  anuPrasad4,
  anuPrasad5,
  monikaHalan,
  monikaHalan1,
  shruteeGanguly,
  shruteeGanguly2,
  shruteeGanguly3,
  shruteeGanguly4,
  peterImanual,
]

export const orientationPhotos = [
  orientation1,
  orientation2,
  orientation3,
  orientation4,
  orientation5,
  orientation6,
  orientation7,
  orientation8,
  orientation9,
  orientation10,
  orientation11,
  orientation12,
  orientation13,
  orientation14,
  orientation15,
  orientation16,
  orientation17,
  orientation18,
  orientation19,
  orientation20,
  orientation21,
  orientation22,
  orientation23,
  orientation24,
  orientation25,
  orientation26,
  orientation27,
  orientation28,
  orientation29,
  orientation30,
  orientation31,
  orientation32,
  orientation33,
  orientation34,
  orientation35,
  orientation36,
  orientation37,
  orientation38,
  orientation39,
  orientation40,
  orientation41,
  orientation42,
  orientation43,
  orientation44,
  orientation45,
  orientation46,
  orientation47,
  orientation48,
  orientation49,
  orientation50,
  orientation51,
  orientation52,
  orientation53,
  orientation54,
  orientation55,
  orientation56,
  orientation57,
  orientation58,
  orientation59,
  orientation60,
  orientation61,
  orientation62,
  orientation63,
  orientation64,
  orientation65,
  orientation66,
  orientation67,
  orientation68,
  orientation69,
  orientation70,
  orientation71,
  orientation72,
  orientation73,
  orientation74,
  orientation75,
  orientation76,
  orientation77,
  orientation78,
  orientation79,
  orientation80,
  orientation81,
  orientation82,
  orientation83,
  orientation84,
  orientation85,
  orientation86,
  orientation87,
  orientation88,
  orientation89,
  orientation90,
  orientation91,
  orientation92,
  orientation93,
  orientation94,
  orientation95,
  orientation96,
  orientation97,
  orientation98,
  orientation99,
  orientation100,
]
